import React, { Component } from "react";
import Grid from "@mui/material/Grid";
import { connect } from "react-redux";
import actionTypes from "../../store/actions";
// API helper and constant
import BusApiCall from "../../helper/axios.js";
import constants from "../../helper/constants";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { withStyles } from "@mui/material/styles";
import Loader from "../../component/loader";
import CreatableSelect from "react-select/creatable";
import ProviderConfirmation from "./providerConfirmation";
import { withTranslation } from "react-i18next";
class ManageServiceProviders extends Component {
  state = {
    loading: true,
    solutionProvidersList: [],
    serviceProvidersList: [],
    selectedServiceProvider: null,
    selectedSalesChannels: [],
    openDialog: false,
    selectedItem: {},
    selectedAction: null,
    selectedSolutonProviders: [],
  };
  componentDidMount() {
    this.props.setCompDidMount();
    this.getProvidersList();
  }

  getProvidersList = () => {
    Promise.all([BusApiCall("GET", `${constants.busV4Url}/service-providers`)])
      .then((res) => {
        let serviceProvidersList = res[0].data;
        serviceProvidersList.filter((a) => (a.selected = false));
        this.setState({
          serviceProvidersList,
          loading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  updateSelectedItems = () => {
    let payload = {
      fromPartyId: this.state.selectedServiceProvider.id,
      toPartyId: this.state.selectedItem.id,
    };
    this.setState({ loading: true });
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/${this.state.selectedAction ? "REMOVE_PARTY_LINK" : "STORE_PARTY_LINK"}/endpoint`,
      payload,
    )
      .then((res) => {
        for (var i = 0; i < this.state.serviceProvidersList.length; i++) {
          if (
            this.state.serviceProvidersList[i].id === this.state.selectedItem.id
          ) {
            this.state.serviceProvidersList[i].selected = this.state
              .selectedAction
              ? false
              : true;
          }
        }
        this.setState({
          loading: false,
          selectedItem: {},
          selectedAction: null,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
          selectedItem: {},
          selectedAction: null,
        });
      });
  };

  selectSolutionProvider = (data) => {
    if (data) {
      if (data._isNew_) {
        console.log("new option not allowed");
      } else {
        this.setState({ loading: true });
        let payload = {
          partyId: data.id,
        };
        BusApiCall(
          "POST",
          `${constants.busInternalUrl}/passthru/GET_PARTY_LINK/endpoint`,
          payload,
        )
          .then((res) => {
            this.setState({
              selectedSalesChannels: res.data.salesChannelProviders,
              selectedSolutonProviders: res.data.solutionProviders,
            });
            this.setState({ loading: false });
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({
              loading: false,
            });
          });
        this.setState({
          selectedServiceProvider: data,
        });
      }
    } else {
      this.setState({
        selectedServiceProvider: {},
      });
    }
  };

  openConfirmationDialog = (item, value) => {
    this.setState({
      selectedItem: item,
      selectedAction: value,
      openDialog: true,
    });
  };

  onConfirmation = (value) => {
    if (value) {
      this.setState({
        openDialog: false,
      });
      this.updateSelectedItems();
    } else {
      this.setState({
        selectedItem: {},
        selectedAction: null,
        openDialog: false,
      });
    }
  };

  render() {
    const CustomColorCheckbox = withStyles({
      root: {
        color: "#b3b3b3",
        "&$checked": {
          color: this.props.tenantData.color
            ? this.props.tenantData.color
            : "#70b2e8",
        },
      },
      checked: {},
    })((props) => <Checkbox color="default" {...props} />);
    const t = this.props.t;
    return (
      <main>
        <Grid container spacing={2}>
          <Grid
            item
            size={{
              xs: 12,
            }}
          >
            <Grid container spacing={2}>
              <Grid
                item
                size={{
                  xs: 4,
                }}
              >
                <h3>{t("SELECT_SERVICE_PROVIDER")}</h3>
                <div style={{ width: "90%" }}>
                  <CreatableSelect
                    // components={{ Option }}
                    classNamePrefix="SearchInputClassPrefix"
                    className={"SearchInputClassPrefix__myinputOuter"}
                    isClearable={true}
                    isSearchable={
                      this.state.selectedServiceProvider ? false : true
                    }
                    name="color"
                    formatCreateLabel={(value) => ""}
                    options={this.state.serviceProvidersList.map((a) => {
                      return {
                        label: a.name,
                        value: a.id,
                        id: a.id,
                      };
                    })}
                    value={this.state.selectedServiceProvider}
                    placeholder=""
                    menuPosition={"fixed"}
                    onChange={(e) => {
                      this.selectSolutionProvider(e);
                    }}
                    onCreateOption={""}
                  />
                  {/* <div>
                                    {this.state.selectedServiceProvider && this.state.selectedServiceProvider.label}
                                </div> */}
                </div>
              </Grid>
              {this.state.selectedServiceProvider ? (
                <>
                  <Grid
                    item
                    size={{
                      xs: 4,
                    }}
                  >
                    <h3>{t("SALES_CHANNELS")}</h3>
                    <FormGroup component="fieldset">
                      {this.state.selectedSalesChannels.map((item, i) => (
                        <FormControlLabel
                          control={
                            <CustomColorCheckbox
                              value={item.id}
                              checked={true}
                              name={"sales" + i}
                            />
                          }
                          label={item.name}
                          key={i}
                          disabled={true}
                        />
                      ))}
                    </FormGroup>
                    {(!this.state.selectedSalesChannels ||
                      this.state.selectedSalesChannels.length === 0) &&
                      t("NO_SALES_CHANNEL_SELECTED")}
                  </Grid>
                  <Grid
                    item
                    size={{
                      xs: 4,
                    }}
                  >
                    <h3>{t("SOLUTION_PROVIDERS")}</h3>
                    <FormGroup component="fieldset">
                      {this.state.selectedSolutonProviders.map((item, i) => (
                        <FormControlLabel
                          control={
                            <CustomColorCheckbox
                              value={item.id}
                              checked={true}
                              name={"sales" + i}
                            />
                          }
                          label={item.name}
                          key={i}
                          disabled={true}
                        />
                      ))}
                    </FormGroup>
                    {(!this.state.selectedSolutonProviders ||
                      this.state.selectedSolutonProviders.length === 0) &&
                      t("NO_SOLUTION_PROVIDER_SELECTED")}
                  </Grid>
                </>
              ) : (
                <Grid
                  item
                  align="center"
                  size={{
                    xs: 4,
                  }}
                >
                  <h3 style={{ marginTop: "60px" }}>
                    {t("NO_SERVICE_PROVIDER_SELECTED")}
                  </h3>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
        <ProviderConfirmation
          item={this.state.selectedItem}
          action={this.state.selectedAction}
          open={this.state.openDialog}
          close={this.onConfirmation}
          t={t}
        />
        <Loader loading={this.state.loading} />
      </main>
    );
  }
}

// Fetch data from redux store
const mapStateToProps = (state) => {
  return {
    providerType: state.auth.providerType,
    tenantId: state.auth.tenantId,
    tenantData: state.auth.tenantData,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(ManageServiceProviders));
